import React from "react";
import "./home-landing.css";

const POINTS = [
  {
    n: "01",
    tone: "pink",
    title: "Observations in seconds",
    text: "Note what a child did in a few taps, add a photo, and watch each child's journey build up on its own.",
  },
  {
    n: "02",
    tone: "blue",
    title: "Plans every guide can follow",
    text: "Weekly planners and ready-made lesson plans keep every classroom moving at the child's pace.",
  },
  {
    n: "03",
    tone: "green",
    title: "One calm channel for families",
    text: "Parents see updates, assignments, and moments in one place, with no chasing and no stray messages.",
  },
];

const GuidesSection = () => (
  <section className="lh-sec" aria-labelledby="lh-guides-title">
    <div className="lh-wrap">
      <h2 className="lh-h2" id="lh-guides-title">
        Guides belong with <mark className="lh-hl">children</mark>, not{" "}
        <span className="lh-strike">paperwork.</span>
      </h2>
      <div className="lh-cards">
        {POINTS.map(({ n, tone, title, text }) => (
          <article className={`lh-card lh-card--${tone}`} key={n}>
            <span className="lh-card__n">{n}</span>
            <h3 className="lh-card__t">{title}</h3>
            <p className="lh-card__p">{text}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default GuidesSection;
